module.exports = __webpack_public_path__ + "static/media/agustina-diaz-gotelli.7e9e6ce6.jpg";